import Model from './base/model';

class RequestProduct extends Model {
  resourceName() {
    return 'request_products';
  }

  fields() {
    return {
      unit_price: '',
      quantity: '',
      sap_line_number: '',
      batch_number: '',
      expected_date: '',
      product: { jsonApi: 'hasOne', type: 'products'},
      request: { jsonApi: 'hasOne', type: 'request'},
    };
  }
}

export default new RequestProduct();
